export const originBottomCenter = {
  vertical: 'bottom',
  horizontal: 'center',
}

export const originTopCenter = {
  vertical: 'top',
  horizontal: 'center',
}